<div
  [formGroup]="passcodeGroup"
  class="passcode-wrapper"
  [ngClass]="{ 'password-display': inputHidden, disabled: disabled }"
>
  <div *ngFor="let passcodeField of passcodeFields" class="digit">
    <ng-container *ngIf="passcodeField.input">
      <div
        class="passcodedigit-wrapper"
        [ngClass]="{
          focused: passcodeField.focused,
          inputted: passcodeField.inputted,
          highlighted: passcodeField.highlighted,
          error: passcodeField.invalid
        }"
      >
        <input
          [id]="passcodeField.id"
          [name]="passcodeField.id"
          type="number"
          [formControlName]="passcodeField.id"
          class="field-input"
          autocomplete="off"
          min="0"
          max="9"
          (focus)="onFocus(passcodeField.index)"
          (blur)="onBlur(passcodeField.index)"
          (keydown)="onKeyDown($event, passcodeField.index)"
          (keyup)="onKeyUp($event, passcodeField.index, passcodeField.id)"
          (change)="formatAndPropagateControlValue()"
          (paste)="onPaste($event)"
          pattern="[0-9]*"
          aria-required="true"
          [attr.aria-invalid]="passcodeField.invalid"
          [attr.aria-label]="passcodeField.label"
          [attr.aria-describedby]="ariaDescribedBy ? ariaDescribedBy : null"
          [attr.disabled]="disabled ? '' : null"
          required
          [attr.data-test-id]="'input-' + passcodeField.id"
          [attr.tabindex]="inputTabindex || null"
          #input
        />

        <span class="highlighted-bar">&nbsp;</span>
        <span class="inputted-disc">&nbsp;</span>
        <span class="input-cursor">&nbsp;</span>
      </div>

      <label for="{{ passcodeField.id }}" class="number" aria-hidden="true">
        {{ passcodeField.number }}
      </label>
    </ng-container>

    <ng-container *ngIf="!passcodeField.input">
      <span class="blank">&nbsp;</span>
      <span class="number" aria-hidden="true"> &nbsp; </span>
    </ng-container>
  </div>
  <show-passcode-toggle
    *ngIf="isToggleable && !scaEnabled"
    (isHiddenChanged)="changePasscodeVisibility($event)"
    [tabindex]="inputTabindex || null"
  >
  </show-passcode-toggle>
</div>
